import React, { useContext } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

import Provider, { RequirePasswordDialogContext, RequirePasswordDialogContextProvider } from './Provider'
import { PointrThemedFormItem } from 'components'
import { IRequirePasswordDialogPageProps } from './Interfaces'
import useRequirePasswordDialog from './Styles'

const RequirePasswordDialogPage: React.FC<IRequirePasswordDialogPageProps> = ({
  onSubmitPassword,
  children,
  onCancel
}) => {
  const { state, handlers } = useContext<RequirePasswordDialogContext>(RequirePasswordDialogContextProvider)
  const classes = useRequirePasswordDialog({})

  const onSubmit = () => {
    const isValid = handlers.checkSubmission()
    if (isValid) {
      handlers.toggleDialog()
      onSubmitPassword(state.password)
      handlers.setPassword('')
    }
  }

  const onCancelPasswordSubmission = () => {
    handlers.toggleDialog()
    handlers.setPassword('')
    if (onCancel) {
      onCancel()
    }
  }

  return (
    <React.Fragment>
      <Dialog
        open={state.isDialogOpen}
        fullWidth
        maxWidth="sm"
        onClose={handlers.toggleDialog}
        aria-labelledby="require-password-dialog"
      >
        <DialogTitle id="require-password-dialog" className={classes.dialogTitle}>
          Password confirmation
        </DialogTitle>
        <form
          onSubmit={event => {
            event.preventDefault()
            onSubmit()
          }}
        >
          <DialogContent>
            <PointrThemedFormItem
              label="Enter your current password to confirm"
              type="password"
              value={state.password}
              error={!state.isValidPassword}
              onChange={event => handlers.setPassword(event.target.value)}
              onBlur={() => handlers.checkPassword()}
              helperText={state.isValidPassword ? null : 'Ooops! Password is invalid'}
            />
          </DialogContent>
          <DialogActions>
            <Button
              id="require-password-dialog-cancel-button"
              autoFocus
              onClick={onCancelPasswordSubmission}
              color="primary"
              type="button"
            >
              Cancel
            </Button>
            <Button id="require-password-dialog-submit-button" type="submit" color="primary">
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {children(state.isDialogOpen, handlers.toggleDialog)}
    </React.Fragment>
  )
}

export default (props: IRequirePasswordDialogPageProps) => (
  <Provider>
    <RequirePasswordDialogPage {...props} />
  </Provider>
)
